import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

const QualificationsIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function QualificationsIcon(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path d='M14 12.5H18V14H14V12.5ZM14 15.5H18V17H14V15.5Z' />
      <path d='M20 7.5H15V4.5C15 3.4 14.1 2.5 13 2.5H11C9.9 2.5 9 3.4 9 4.5V7.5H4C2.9 7.5 2 8.4 2 9.5V20.5C2 21.6 2.9 22.5 4 22.5H20C21.1 22.5 22 21.6 22 20.5V9.5C22 8.4 21.1 7.5 20 7.5ZM11 7.5V4.5H13V9.5H11V7.5ZM20 20.5H4V9.5H9C9 10.6 9.9 11.5 11 11.5H13C14.1 11.5 15 10.6 15 9.5H20V20.5Z' />
      <path d='M9 15.5C9.82843 15.5 10.5 14.8284 10.5 14C10.5 13.1716 9.82843 12.5 9 12.5C8.17157 12.5 7.5 13.1716 7.5 14C7.5 14.8284 8.17157 15.5 9 15.5Z' />
      <path d='M11.08 16.68C10.44 16.4 9.74 16.25 9 16.25C8.26 16.25 7.56 16.4 6.92 16.68C6.36 16.92 6 17.46 6 18.07V18.5H12V18.07C12 17.46 11.64 16.92 11.08 16.68Z' />
    </SvgIcon>
  )
})

QualificationsIcon.displayName = 'QualificationsIcon'

export default QualificationsIcon
